import RouterView from '@/page/main/DefaultRouterView'


import UserSet from '@/page/set/userSet'
import RoleList from '@/page/set/rolelist'
import ResourceList from '@/page/set/resourceList'
import NodeUserList from '@/page/set/nodeUserList'

import ApprovalSet from '@/page/set/approvalSet'
import TeamList from '@/page/project/teamlist'

export default {
  path: '/Set',
  component: RouterView,
  children: [{
      path: 'UserGroup',
      meta: {
        type: ['role', 'userGroup'],
        title: '分配权限组'
      },
      component: UserSet
    }, {
      path: 'Role',
      meta: {
        type: ['role', 'roleList'],
        title: '权限组设置'
      },
      component: RoleList
    }, {
      path: 'Resource',
      meta: {
        type: ['role', 'resourceList'],
        title: '权限资源管理'
      },
      component: ResourceList
    }, {
      path: 'Approval',
      meta: {
        type: ['setting', 'approvalSet'],
        title: '权限资源管理'
      },
      component: ApprovalSet
    },
    {
      path: 'Team',
      meta: {
        type: ['setting', 'team'],
        title: '项目组'
      },
      component: TeamList
    }, {
      path: 'Node',
      meta: {
        type: ['setting', 'nodeUser'],
        title: '固定人员设置'
      },
      component: NodeUserList
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/set.js